import { render, staticRenderFns } from "./GuardRegister.vue?vue&type=template&id=4547e734"
import script from "./GuardRegister.vue?vue&type=script&lang=js"
export * from "./GuardRegister.vue?vue&type=script&lang=js"
import style0 from "./GuardRegister.vue?vue&type=style&index=0&id=4547e734&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports